<div class="mx-auto max-w-[1600px] p-4">
  @if (pageLoading()) {
    <div class="flex min-h-[500px] items-center justify-center">
      <app-loading />
    </div>
  } @else if (accessDenied()) {
    <div class="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 16 16">
        <path
          class="fillDangerColor"
          fill-rule="evenodd"
          d="m7.493.015l-.386.04c-1.873.187-3.76 1.153-5.036 2.579C.66 4.211-.057 6.168.009 8.253c.115 3.601 2.59 6.65 6.101 7.518a8.03 8.03 0 0 0 6.117-.98a8 8 0 0 0 3.544-4.904c.172-.701.212-1.058.212-1.887s-.04-1.186-.212-1.887C14.979 2.878 12.315.498 9 .064C8.716.027 7.683-.006 7.493.015m1.36 1.548a6.3 6.3 0 0 1 1.987.597c.698.34 1.18.686 1.747 1.253A6 6 0 0 1 13.84 5.16c.445.915.646 1.798.646 2.84a6.2 6.2 0 0 1-.66 2.867c-.172.351-.519.914-.681 1.105l-.055.065l-4.563-4.564L3.963 2.91l.065-.055c.191-.162.754-.509 1.105-.681a6.44 6.44 0 0 1 3.72-.611M7.48 8.534l4.56 4.561l-.067.053a7.7 7.7 0 0 1-1.106.68a6.8 6.8 0 0 1-1.987.616c-.424.065-1.336.065-1.76 0c-1.948-.296-3.592-1.359-4.627-2.993a7.5 7.5 0 0 1-.634-1.332a6.6 6.6 0 0 1-.189-3.584a6.8 6.8 0 0 1 1.096-2.388c.07-.095.133-.173.141-.173s2.065 2.052 4.573 4.56" />
      </svg>
      <h2 class="text-xl font-bold text-gray-800" i18n="@@product.error.accessDeniedTitle">Access Denied</h2>
      <p class="max-w-sm text-sm text-gray-500" i18n="@@product.error.accessDeniedMessage">
        You do not have permission to access this page.
      </p>
      <button
        onclick="history.back()"
        class="border-primary text-primary hover-bg-primary mt-2 rounded-[6px] border px-5 py-2 text-sm font-medium transition-colors hover:cursor-pointer hover:text-white">
        Go Back
      </button>
    </div>
  } @else if (pageError()) {
    <!-- <div class="flex flex-col items-center justify-center gap-4 py-20 text-center">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#C42727" stroke-width="1.5">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <h2 class="text-xl font-bold text-gray-800" i18n="@@product.error.genericTitle">Something Went Wrong</h2>
      <p class="max-w-sm text-sm text-gray-500">{{ pageError() }}</p>
      <button onclick="history.back()" class="mt-2 rounded-[6px] border border-[#C42727] px-5 py-2 text-sm font-medium text-[#C42727] transition-colors hover:cursor-pointer hover:bg-[#C42727] hover:text-white">
        Go Back
      </button>
    </div> -->
    <app-error [apiError]="pageError() ?? ''" />
  } @else {
    <div class="mb-5 px-1">
      <h2 class="textTabsColor text-[26px] font-bold" i18n="@@product.page.title">Add Product</h2>
    </div>

    <div
      class="borderDivColor bgSoftGrayColor mb-8 flex w-full items-stretch overflow-hidden rounded-lg border shadow-sm">
      <div
        (click)="activeStep.set(1)"
        class="relative flex h-16 flex-1 cursor-pointer items-center justify-center transition-all hover:bg-gray-50"
        [class.bg-white]="activeStep() === 1">
        <div class="z-10 flex items-center gap-3">
          <div
            class="flex h-7 w-7 items-center justify-center rounded-full border-2 text-[13px] font-bold transition-colors"
            [class]="activeStep() >= 1 ? 'bgTabsColor borderTabsColor text-white' : 'border-gray-300 text-gray-500'">
            @if (activeStep() > 1 && createdProductId()) {
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <path fill="currentColor" d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
              </svg>
            } @else {
              01
            }
          </div>
          <span
            class="text-[15px] font-bold tracking-wide"
            [class]="activeStep() === 1 ? 'textTabsColor' : 'text-gray-500'"
            i18n="@@product.step.productInfo">
            PRODUCT INFO
          </span>
        </div>
        @if (activeStep() === 1) {
          <div class="bgTabsColor absolute bottom-0 left-0 h-[3px] w-full"></div>
        }
      </div>

      @if (hasSubProducts()) {
        <div
          (click)="createdProductId() ? activeStep.set(2) : null"
          class="relative flex h-16 flex-1 cursor-pointer items-center justify-center border-l border-gray-200 transition-all hover:bg-gray-50"
          [class.bg-white]="activeStep() === 2"
          [class.opacity-40]="!createdProductId()"
          [class.pointer-events-none]="!createdProductId()">
          <div class="z-10 flex items-center gap-3">
            <div
              class="flex h-7 w-7 items-center justify-center rounded-full border-2 text-[13px] font-bold transition-colors"
              [class]="activeStep() >= 2 ? 'bgTabsColor borderTabsColor text-white' : 'border-gray-300 text-gray-500'">
              @if (activeStep() > 2) {
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M10.243 16.314L6 12.07l1.414-1.414l2.829 2.828l5.656-5.657l1.415 1.415z" />
                </svg>
              } @else {
                02
              }
            </div>
            <span
              class="text-[15px] font-bold tracking-wide"
              [class]="activeStep() === 2 ? 'textTabsColor' : 'text-gray-500'"
              i18n="@@product.step.defineAttributes">
              DEFINE ATTRIBUTES
            </span>
          </div>
          @if (activeStep() === 2) {
            <div class="bgTabsColor absolute bottom-0 left-0 h-[3px] w-full"></div>
          }
        </div>

        <div
          (click)="productAttributes().length > 0 ? activeStep.set(3) : null"
          class="relative flex h-16 flex-1 cursor-pointer items-center justify-center border-l border-gray-200 transition-all hover:bg-gray-50"
          [class.bg-white]="activeStep() === 3"
          [class.opacity-40]="productAttributes().length === 0"
          [class.pointer-events-none]="productAttributes().length === 0">
          <div class="z-10 flex items-center gap-3">
            <div
              class="flex h-7 w-7 items-center justify-center rounded-full border-2 text-[13px] font-bold transition-colors"
              [class]="activeStep() === 3 ? 'bgTabsColor borderTabsColor text-white' : 'border-gray-300 text-gray-500'">
              03
            </div>
            <span
              class="text-[15px] font-bold tracking-wide"
              [class]="activeStep() === 3 ? 'textTabsColor' : 'text-gray-500'"
              i18n="@@product.step.addSubProducts">
              ADD SUB PRODUCTS
            </span>
          </div>
          @if (activeStep() === 3) {
            <div class="bgTabsColor absolute bottom-0 left-0 h-[3px] w-full"></div>
          }
        </div>
      }
    </div>

    <div class="min-h-[400px] rounded-xl border border-gray-100 bg-white p-8 shadow-sm">
      @switch (activeStep()) {
        @case (1) {
          <app-product-info-step (onComplete)="onStepOneComplete($event)" (onToggleSub)="hasSubProducts.set($event)" />
        }
        @case (2) {
          <app-attributes-step
            [productId]="createdProductId()!"
            [initialAttributes]="productAttributes()"
            (onComplete)="onStepTwoComplete($event)"
            (onBack)="activeStep.set(1)" />
        }
        @case (3) {
          <app-sub-products-step
            [productId]="createdProductId()!"
            [attributes]="mappedAttributes()"
            [parentTitleEn]="productTitleEn()"
            [parentTitleAr]="productTitleAr()"
            (onBack)="activeStep.set(2)"
            (onFinalSave)="showSuccess.set(true)" />
        }
      }
    </div>
  }
</div>

@if (showSuccess()) {
  <app-successful-notification
    type="success"
    i18n-title="@@product.success.created"
    title="Product has been created successfully." />
}
